import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FaEdit } from 'react-icons/fa';
import { AiOutlineFileExcel, AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import styles from '../../assets/css/TogglerButton.module.css';
import { notifySet } from '../../Services/Actions/CommonActions';
import { activateCategory, getCategories } from '../../Services/Utils/ServiceProviderApis';
import { downloadXL, getImage } from '../../Services/Utils/FileApis';
import { fromEpochToDate, isEmpty } from '../../Services/config/globals';
import { UseStyles } from '../../components/TableStyles/tableSX';

// category disable enable toggler
function Toggler(props) {
  const dispatch = useDispatch();
  const { categoryData } = props;
  const [isCategoryActive, setIsCategoryActive] = useState(categoryData.active);

  const handleCategoryActiveChange = (e, res) => {
    activateCategory({ id: res.id }).then((resp) => {
      if (resp.hasError === false) {
        dispatch(notifySet({ type: 'success', message: resp.message }));
        setIsCategoryActive(!isCategoryActive);
      } else if (resp.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        id="Btn"
        className={`${styles['switch-input']}`}
        checked={isCategoryActive}
        onChange={(e) => handleCategoryActiveChange(e, categoryData)}
      />
      <span className={`${styles.slider} ${styles['slider-round']}`} />
    </label>
  );
}

function CategoriesList() {
  const classes = UseStyles();

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(20);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };

  const downloadFile = () => {
    downloadXL('category', {});
  };

  const [category, setCategory] = useState([]);

  function categoryView() {
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage
    };
    getCategories({ }, params).then((res) => {
      setCategory(res.list);
      setListRecordSize(res.records);
    });
  }
  useEffect(() => {
    categoryView();
  }, [itemOffset, rowsPerPage]);

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-2 col-lg-2">
            <div className="title-left-con">
              <h6>Categories</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-10 col-lg-10">
            <div className="title-right-con list-ul-con">
              <ul>
                <li>
                  <Link
                    className={`addcircle excel${isEmpty(category) ? ' disabled' : ''}`}
                    title={isEmpty(category) ? 'Empty Data' : 'Download data in XL format'}
                    onClick={!isEmpty(category) ? downloadFile : () => {}}
                  >
                    <AiOutlineFileExcel />
                  </Link>
                </li>
                <li>
                  <Link
                    className="addcircle"
                    to="/categories/add-category"
                  >
                    <AiOutlinePlus />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isEmpty(category) && <p className="text-center" style={{ marginTop: '100px' }}>No category found</p> }
      {isEmpty(category) ? (
        ''
      ) : (
        <div>
          <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
            <TableContainer
              component={Paper}
              className="tableContainer"
              sx={{ maxHeight: 720, marginRight: 'auto' }}
            >
              <Table
                stickyHeader
                className={classes.root}
              >
                <TableHead>
                  <TableRow>
                    <TableCell width={70}>No.</TableCell>
                    <TableCell>Category Name</TableCell>
                    <TableCell width={150}>Create Date</TableCell>
                    <TableCell width={100}>Status</TableCell>
                    <TableCell width={100}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {category.map((categoryData, key) => (
                    <TableRow
                      key={key}
                      hover
                      tabIndex={-1}
                    >
                      <TableCell>{key + 1 + itemOffset}</TableCell>
                      <TableCell>
                        <img
                          alt=""
                          style={{ marginRight: '5px', backgroundColor: 'black' }}
                          src={`${getImage(categoryData.bannerFileView)}`}
                          height="30px"
                          width="30px"
                        />
                        {categoryData.name}
                      </TableCell>
                      <TableCell>{fromEpochToDate(categoryData.createDate)}</TableCell>
                      <TableCell>
                        <Toggler categoryData={categoryData} />
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Edit">
                          <Link
                            to={`/categories/edit-category/${categoryData.id}`}
                            style={{ verticalAlign: 'text-bottom' }}
                          >
                            <FaEdit style={{ color: 'black', fontSize: '20px' }} />
                          </Link>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={listRecordSize}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="tablepaginationcon"
            />
          </Paper>
        </div>
      )}
    </div>
  );
}

export default CategoriesList;
